export default __webpack_public_path__ + "static/13_asadahasg1-01-e8668434f5849d3e6d90152a71bbdef9.webp";